export default __webpack_public_path__ + "static/media/update.204cd0b7.svg";